// extracted by mini-css-extract-plugin
module.exports = {"iconLeft":"system_button-module--iconLeft--23mA9","iconRight":"system_button-module--iconRight--lPmDB"};